import { render, staticRenderFns } from "./CreateCertificationModal.vue?vue&type=template&id=a4e038a0&"
import script from "./CreateCertificationModal.vue?vue&type=script&lang=js&"
export * from "./CreateCertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports